const LoadingIndicator = () => {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-100 z-50">
        <div className="text-center">
          <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]">
            <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
              Loading...
            </span>
          </div>
          <h2 className="mt-4 text-xl font-semibold text-gray-800">Loading Dashboard</h2>
          <p className="mt-2 text-gray-600">Please wait while we prepare your data</p>
        </div>
      </div>
    );
  };
  
  export default LoadingIndicator;